// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pPqB","container":"Footer_container__188QZ","spacer":"Footer_spacer__1lE6T"};